import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaTimes, FaExclamationTriangle } from 'react-icons/fa';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, userName }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal delete-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{t('admin.user_management.confirm_delete')}</h2>
          <button className="close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="delete-content">
          <div className="warning-icon">
            <FaExclamationTriangle style={{ fontSize: '48px', color: '#dc2626' }} />
          </div>
          <p className="delete-message">
            {t('admin.user_management.messages.delete_confirm', { userName })}
          </p>
          <p className="delete-warning">
            {t('admin.user_management.messages.delete_warning')}
          </p>
        </div>

        <div className="modal-actions">
          <button type="button" className="cancel-btn" onClick={onClose}>
            {t('admin.user_management.actions.cancel')}
          </button>
          <button type="button" className="delete-confirm-btn" onClick={onConfirm}>
            {t('admin.user_management.actions.delete')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;